import globalConfig from '@utiles/officialStore/globalConfig';
const mainHost = globalConfig.getMainHost();

const gameInfoConfig = {
  175: {
    bankTip: [], // 银行汇款提示，不填则使用默认值
    activityFloat: {
      // 跳转活动悬浮图
      img: require('@assets/image/officialTopup/activity/float-activity-175.png'),
      url: `https://auto-page.${mainHost}/zclc01/?scid=webstore_banner`
    },
    autoChangeProduct: false, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  390: {
    // // 添加到桌面快捷方式领奖
    // pwaAward: {
    //   open: true,
    //   activityName: 'mudepwagift'
    // },
    // // 添加到桌面背景和按钮
    // pwaInstallPopupBg: require('@assets/image/officialTopup/muglo/pwa-install-popup-bg.png'),
    // pwaInstallPopupBtn: require('@assets/image/officialTopup/muglo/pwa-install-popup-btn.png'),
    // pwaInstalledAward: require('@assets/image/officialTopup/muglo/pwa-installed-award.png'),
    bankTip: [], // 银行汇款提示，不填则使用默认值
    activityFloat: {
      // 跳转活动悬浮图
      img: '',
      url: ''
    },
    autoChangeProduct: false, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  402: {
    bankTip: [
      '1、銀行虛擬帳號儲值只能進行通寶儲值哦',
      '2、匯款金額須與選擇金額保持一致才能正常獲取資源',
      '3、使用銀行匯款可能導致部分優惠無法使用，請以頁面實際顯示為準，如有疑問請諮詢客服'
    ],
    activityFloat: {
      // 跳转活动悬浮图
      img: '',
      url: ''
    },
    autoChangeProduct: false, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  405: {
    bankTip: [], // 银行汇款提示，不填则使用默认值
    activityFloat: {
      // 跳转活动悬浮图
      img: '',
      url: ''
    },
    autoChangeProduct: true, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  410: {
    bankTip: [], // 银行汇款提示，不填则使用默认值
    activityFloat: {
      // 跳转活动悬浮图
      img: require('@assets/image/officialTopup/activity/float-activity-410.png'),
      url: `https://auto-page.${mainHost}/dbzjplc01/`
    },
    autoChangeProduct: false, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  412: {
    bankTip: [], // 银行汇款提示，不填则使用默认值
    activityFloat: {
      // 跳转活动悬浮图
      img: require('@assets/image/officialTopup/activity/float-activity-412.png'),
      url: `https://auto-page.${mainHost}/dbzkrlc01/`
    },
    autoChangeProduct: false, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  191: {
    // 是否展示上线前弹窗
    isShowPreRightsPopup: true,
    offLineTime: '2025-07-16T00:00:00+00:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-07-16 00:00:00 (UTC)',
      'zh-CN': '2025-07-16 00:00:00 (UTC)',
      'vi-VN': '00:00:00 (UTC) ngày 16/07/2025',
      'tr-TR': '16/07/2025 00:00:00 (UTC)',
      'th-TH': '2025-07-16 เวลา 00:00:00 น.(UTC)',
      'ru-RU': '2025/07/16 00:00:00 (UTC)',
      'pt-PT': '16/07/2025 00:00:00 (UTC)',
      'pl-PL': '2025/07/16 00:00:00 (UTC)',
      'ko-KR': '2025-07-16 00:00:00(UTC)',
      'ja-JP': '2025 年 7 月 16 日 00:00:00(UTC)',
      'it-IT': '16/07/2025 00:00:00 (UTC)',
      'id-ID': '16/07/2025 00:00:00 (UTC)',
      'fr-FR': '16/07/2025 00:00:00 (UTC)',
      'es-ES': '16/07/2025 00:00:00 (UTC)',
      'en-US': '2025/07/16 00:00:00 (UTC)',
      'de-DE': '16.07.2025, 00:00:00 Uhr (UTC)',
      'ar-SA': '16-07-2025 00:00:00 (UTC)'
    },
    // 是否上线权益中心
    isOnlineRightsCenter: false,
    // 权益中心上线时间
    onlineRightsCenterTime: '', // 权益中心上线时间，需加上时区信息
    // 上线前弹窗链接
    preRightsPopupLink: '',
    // 权益中心链接
    rightsCenterLink: '',
    activityFloat: {
      // 跳转活动悬浮图
      img: '',
      url: ''
    },
    autoChangeProduct: false, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: false, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: false, // 隐藏客服
    hideCoupon: false // 隐藏查看优惠券
  },
  386: {
    bankTip: [], // 银行汇款提示，不填则使用默认值
    activityFloat: {
      // 跳转活动悬浮图
      img: '',
      url: ''
    },
    autoChangeProduct: true, // 当从微端带商品参数跳转三方支付页时，如果商品不存在则内购礼包商品ID转代币商品ID
    hideDefaultLogin: true, // 隐藏默认登录方式（账密登录、OTP登录）
    hideService: true, // 隐藏客服
    hideCoupon: true // 隐藏查看优惠券
  }
};

export const ZTMSLG_GAMES = [191, 225, 227, 284];
export const DTMSLG_GAMES = [285, 354, 355];

export const DOMAIN_MAP = {
  191: [window.atob('MzdnYW1lcy5jb20='), 'pnsofficial.com', 'blancozone.com'], // 主版本游戏域名：需要包含分版本游戏域名
  225: ['blancozone.com'], // 分版本游戏域名
  227: ['blancozone.com'], // 分版本游戏域名
  284: [window.atob('MzdnYW1lcy5jb20='), 'pnsofficial.com'], // 分版本游戏域名

  285: [window.atob('MzdnYW1lcy5jb20=')], // 主版本游戏域名：需要包含分版本游戏域名
  354: ['blancozone.com'], // 分版本游戏域名
  355: [] // 分版本游戏域名，看到支付页管理后台没有配置，先空着
};

export const mergeGameDomainList = domainList => {
  const set = new Set(domainList);
  const gameId =
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') ||
    '';
  if (DOMAIN_MAP[Number(gameId)]) {
    DOMAIN_MAP[Number(gameId)].forEach(domain => {
      set.add(domain);
    });
  }
  return Array.from(set);
};

export default gameInfoConfig;
